import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M9 15q-2.513 0-4.256-1.744T3 9t1.744-4.256Q6.487 3 9 3q1.294 0 2.475.534A5.7 5.7 0 0 1 13.5 5.063V3.75q0-.318.216-.535A.72.72 0 0 1 14.25 3q.319 0 .535.216A.72.72 0 0 1 15 3.75V7.5q0 .318-.216.535a.72.72 0 0 1-.534.215H10.5a.73.73 0 0 1-.535-.216.72.72 0 0 1-.215-.534q0-.318.216-.535a.72.72 0 0 1 .534-.215h2.4q-.6-1.05-1.641-1.65T9 4.5q-1.875 0-3.187 1.313Q4.5 7.125 4.5 9t1.313 3.188T9 13.5q1.275 0 2.335-.647a4.46 4.46 0 0 0 1.64-1.734q.15-.263.422-.365a.8.8 0 0 1 .553-.01q.3.094.431.393.132.3-.018.563-.77 1.5-2.194 2.4Q10.744 15 9 15"
    }, null, -1)
  ]))]))
}
export default { render: render }